// // blogslider start
// $('.mobile-slider').slick({
//   dots: false,
//   arrows:false,
//   infinite: false,
//   infinite: true,
//   fade: true,
//     speed: 500,
//     cssEase: 'linear',
//     autoplay: true,
//     autoplaySpeed: 2000,
//   slidesToShow: 1,
//   slidesToScroll: 1,
//   responsive: [
//     {
//       breakpoint: 1024,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1,
//         infinite: true,
//         dots: false
//       }
//     },
//     {
//       breakpoint: 600,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     },
//     {
//       breakpoint: 480,
//       settings: {
//         slidesToShow: 1,
//         slidesToScroll: 1
//       }
//     }
//   ]
// });

$(document).ready(function() {
  // $('.security-slider').slick({
  //   dots: false,
  //   arrows: false,
  //   infinite: false,
  //   speed: 500,
  //   autoplay: true,
  //   autoplaySpeed: 2000,
  //   slidesToShow: 1,
  //   slidesToScroll: 1,
  // });

  // Initially hide all ticks
  $('.security-list .tick').hide();

  // Show the tick for the first slide
  $('.security-list li').eq(0).find('.tick').show();

  // Listen for the slider change
  $('.security-slider').on('afterChange', function(event, slick, currentSlide) {
    // Show the tick for the current slide
    $('.security-list li').eq(currentSlide).find('.tick').show();
  });
});


// blogslider end

// product slider jas start

 // simple slick slider end

// wow animation js 

$(function () {
    new WOW().init();
  });


// responsive menu js 





// slick slider in tabs js start

function openCity(evt, cityName) {
  // Declare all variables
  var i, tabcontent, tablinks;

  // Get all elements with class="tabcontent" and hide them
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
  }

  // Get all elements with class="tablinks" and remove the class "active"
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace("active", "");
  }

  // Show the current tab, and add an "active" class to the button that opened the tab
  document.getElementById(cityName).style.display = "block";
  evt.currentTarget.className += "active";
}


// slick slider in tabs js end



let lastScrollTopold = 0;

$(window).on('scroll', function() {
    let scrollTop = $(this).scrollTop();

    if (scrollTop > lastScrollTopold) {
        // Scrolling down
        if (scrollTop > 1) {
            $('header').addClass("sticky");
        }
    } else {
        // Scrolling up
        $('header').removeClass("sticky");
    }

    lastScrollTopold = scrollTop;
});

document.querySelectorAll('.faq-question').forEach(button => {
    button.addEventListener('click', () => {
      console.log('faq click');
        const faqItem = button.parentElement;
        const isActive = faqItem.classList.contains('active');

        // Close all FAQ items
        document.querySelectorAll('.faq-item').forEach(item => {
            item.classList.remove('active');
        });

        // Open clicked item if it wasn't active
        if (!isActive) {
            faqItem.classList.add('active');
        }
    });
});